<template>
	<main class="payment-result">
		<div class="payment-result__inner _cnt">
			<div class="payment-result__title _md">
				{{
					$t(
						`Thank you - your payout was successful. You will shortly receive a confirmation to your e-mail. In case of any questions, please contact us at.`
					)
				}}
				<a :href="`mailto:${this.footerSupportEmail}`">{{ this.footerSupportEmail }}</a>
			</div>
		</div>
	</main>
</template>
<script>
import { ButtonThemes } from '@/components/base/BaseButton.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'PayoutSuccessPage',
	components: {},
	props: ['footerSupportEmail'],
	data() {
		return {
			ButtonThemes,
		};
	},
	computed: {
		...mapGetters('app', ['currencyCode']),
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.payment-result {
	@include adaptiveValue('padding-top', 50, 25);
	@include adaptiveValue('padding-bottom', 50, 20);
	@include header-indent;
	&__inner {
	}
	&__top {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 37, 20);
		}
		@media (min-width: $md5) {
			display: flex;
			justify-content: center;
			flex-wrap: wrap;
			gap: 20px;
		}
	}
	&__title {
		text-align: center;
		margin: 0 auto;
		span {
			color: var(--secondary-color);
		}
		a {
			color: var(--secondary-color);
			text-decoration: none;
			&:hover {
				text-decoration: underline;
			}
		}
	}
	&__line {
		max-width: 710px;
		margin: 0 auto;
	}
}
</style>
